module.exports = __webpack_public_path__ + "img/ahmad-rahadian.f037642a.png";